import { render, staticRenderFns } from "./Posting.vue?vue&type=template&id=7a6d7f76"
import script from "./Posting.vue?vue&type=script&lang=js"
export * from "./Posting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports